/** `crypto.randomUUID` needs a secure context; a storefront opened over plain
 *  http on a test domain still has to be able to submit exactly once. */
export function newIdempotencyKey(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID()
  }
  const random = Math.random().toString(36).slice(2)
  return `bk-${Date.now().toString(36)}-${random}`
}
